import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import AssessmentApiCall from 'ASSESSMENT/AssessmentApiCall';
import Spinner from 'ASSESSMENT/CommonResources/SpinnerLoader/Spinner';
import SuccessModal from 'ASSESSMENT/CommonResources/SuccessModal/SuccessModal';
import ResultDetails from 'ASSESSMENT/Components/ResultList/ResultDetails/ResultDetails';
import ReactToPrint from 'react-to-print';
import 'ASSESSMENT/Components/StudentResultList/studentresultlist.css';

class StudentResultList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            instituteUrl: this.props.match.params.instituteUrl,
            instituteData: {},
            instituteId: '',
            isValidUrl: '',

            studentPRN: '',
            studentDOB: '',
            verificationError: '',
            verifyingStudent: false,
            studentData: {},
            studentId: '',
            acaYr: '',
            studentVerified: false,

            resultList: {},
            sortedIdArray: [],
            selectedResultId: '',
            pageIndex: 1,
            limit: 250,
            total: 0,
            fetchingResultList: false,
            gradePointLabels: {},

            successModal: false,
            successModalType: '',
            successMessage: ''
        };
    }

    componentDidMount() {
        this.apiCallToGetInstituteDetails();
    }

    // API CALL METHOD TO GET INSTITUTE DETAILS
    apiCallToGetInstituteDetails = async () => {
        let requestData = {
            url: this.state.instituteUrl,
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'getInstituteDataByURL',
            requestData,
            '/api/assessment/assessmentLogin/generic_api.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                if (jsonResponse.APIResult.success == 'true') {
                    this.setState({
                        instituteData: apiResult,
                        instituteId: apiResult.InstituteId,
                        isValidUrl: 'true'
                    });
                } else {
                    this.setState({
                        isValidUrl: 'false'
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting institute details. Please try again later.'
                });
            }
        }
    }

    // METHOD TO VALIDATE STUDENT CREDENTIALS
    validateStudentCredentials = () => {
        let validData = true;

        if (this.state.studentPRN.trim() == '' || this.state.studentDOB == '') {
            validData = false;
            this.setState({
                verificationError: 'Please enter PRN and Date of Birth to view result.'
            });
        }

        if (validData) {
            this.setState({
                verificationError: ''
            }, () => {
                this.apiCallToVerifyStudentResultCreds();
            });
        }
    }

    // API CALL METHOD TO VERIFY STUDENT RESULT CREDENTIALS
    apiCallToVerifyStudentResultCreds = async () => {
        this.setState({
            verifyingStudent: true,
            studentVerified: false,
            studentData: {},
            studentId: '',
            acaYr: '',
            resultList: {},
            sortedIdArray: [],
            selectedResultId: '',
            total: 0,
            pageIndex: 1
        });

        let requestData = {
            iid: this.state.instituteId,
            student_prn: this.state.studentPRN.trim(),
            student_dob: this.state.studentDOB
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'assessmentVerifyStudentResultCreds',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToVerifyStudentResultCreds();
            }, 1000);
        } else {
            if (jsonResponse.success && jsonResponse.APIResult.success == 'true') {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    studentData: apiResult.studentData || {},
                    studentId: apiResult?.studentData?.studentId || '',
                    acaYr: apiResult.acaYr || '',
                    studentVerified: true,
                    verifyingStudent: false,
                    verificationError: ''
                }, () => {
                    this.apiCallToGetStudentResultList(1);
                });
            } else {
                this.setState({
                    verifyingStudent: false,
                    studentVerified: false,
                    verificationError: 'Invalid PRN or Date of Birth. Please verify and try again.'
                });
            }
        }
    }

    // API CALL METHOD TO GET VERIFIED STUDENT RESULT LIST
    apiCallToGetStudentResultList = async (pageNumber = this.state.pageIndex) => {
        this.setState({
            fetchingResultList: true
        });

        let requestData = {
            iid: this.state.instituteId,
            studentId: this.state.studentId,
            aca_yr: this.state.acaYr,
            page_index: pageNumber,
            limit: this.state.limit
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'getStudentResultList',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetStudentResultList(pageNumber);
            }, 1000);
        } else {
            if (jsonResponse.success && jsonResponse.APIResult.success == 'true') {
                let apiResult = jsonResponse.APIResult.data;
                let sortedIdArray = jsonResponse.APIResult.sortedIdArray || [];

                this.setState({
                    resultList: apiResult.resultList || {},
                    sortedIdArray,
                    selectedResultId: sortedIdArray.length > 0 ? 'consolidated' : '',
                    total: jsonResponse.APIResult.totalCount || 0,
                    pageIndex: pageNumber,
                    fetchingResultList: false,
                    gradePointLabels: jsonResponse.APIResult.gradePointLabels || {},
                    instituteData: {
                        ...this.state.instituteData,
                        InstituteName: apiResult.InstituteName || this.state.instituteData.InstituteName,
                        InstituteLogo: apiResult.InstituteLogo || this.state.instituteData.InstituteLogo,
                    }
                });
            } else {
                this.setState({
                    fetchingResultList: false,
                    resultList: {},
                    sortedIdArray: [],
                    selectedResultId: ''
                });
            }
        }
    }

    // METHOD TO UPDATE PAGINATION COUNT
    updatePaginationCount = (pageNumber) => {
        this.apiCallToGetStudentResultList(pageNumber);
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    render() {
        let selectedResult = this.state.selectedResultId != ''
            ? this.state.resultList[this.state.selectedResultId]
            : undefined;
        let showConsolidatedResult = this.state.selectedResultId == 'consolidated';

        return (
            <>
                {
                    this.state.isValidUrl == 'true' ?
                        <div className="container-fluid student-result-page">
                            <div className='institute-header'>
                                <div className='institute-logo'>
                                    <img src={this.state.instituteData.InstituteLogo} height={40} alt='Institute Logo' />
                                </div>
                                <div className='institute-name'>
                                    {ReactHtmlParser(this.state.instituteData.InstituteName || '')}
                                </div>
                            </div>
                            <hr />
                            <div className='page-title'>
                                <h4>View Result</h4>
                            </div>

                            <div className='student-search-container'>
                                <div className='search-input-container student-result-search-input'>
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Enter PRN / University Number</label>
                                        <input
                                            className='form-control'
                                            type='text'
                                            placeholder='Enter PRN / University Number'
                                            value={this.state.studentPRN}
                                            onChange={(e) => this.setState({ studentPRN: e.target.value, selectedResultId: "", studentVerified: false, verificationError: '' })}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontWeight: 'bold' }}>Enter Date of Birth</label>
                                        <input
                                            className='form-control'
                                            type='date'
                                            value={this.state.studentDOB}
                                            onChange={(e) => this.setState({ studentDOB: e.target.value, selectedResultId: "", studentVerified: false, verificationError: '' })}
                                        />
                                    </div>
                                </div>
                                <div className='button-container'>
                                    <button
                                        className='btn btn-primary'
                                        onClick={() => this.validateStudentCredentials()}
                                        disabled={this.state.verifyingStudent || this.state.instituteId == ''}
                                    >
                                        {this.state.verifyingStudent ? 'Verifying...' : 'Verify & View Result'}
                                    </button>
                                </div>
                            </div>

                            {
                                this.state.verificationError != '' &&
                                <div className='invalid-student'>
                                    <p>{this.state.verificationError}</p>
                                </div>
                            }

                            {
                                this.state.studentVerified &&
                                <>
                                    {
                                        this.state.fetchingResultList ?
                                            <Spinner />
                                            :
                                            <>
                                                {
                                                    this.state.sortedIdArray.length > 0 ?
                                                        <>
                                                            <div className='result-tab-wrapper'>
                                                                <ul className='nav nav-tabs flex-nowrap overflow-auto result-tab-container'>
                                                                    <li className='nav-item' key='consolidated'>
                                                                        <button
                                                                            type='button'
                                                                            className={showConsolidatedResult ? 'nav-link active result-tab-button' : 'nav-link result-tab-button'}
                                                                            onClick={() => this.setState({ selectedResultId: 'consolidated' })}
                                                                        >
                                                                            Consolidated View
                                                                        </button>
                                                                    </li>
                                                                    {
                                                                        this.state.sortedIdArray.map((resultId) => {
                                                                            let resultData = this.state.resultList[resultId];
                                                                            return (
                                                                                <li className='nav-item' key={resultData.uniqueId}>
                                                                                    <button
                                                                                        type='button'
                                                                                        className={this.state.selectedResultId == resultId ? 'nav-link active result-tab-button' : 'nav-link result-tab-button'}
                                                                                        onClick={() => this.setState({ selectedResultId: resultId })}
                                                                                    >
                                                                                        {resultData.title}
                                                                                    </button>
                                                                                </li>
                                                                            );
                                                                        })
                                                                    }
                                                                </ul>
                                                            </div>

                                                            {
                                                                showConsolidatedResult ?
                                                                    <>
                                                                        <div
                                                                            className='consolidated-result-print'
                                                                            ref={(el) => { this.consolidatedPrintReference = el; }}
                                                                        >
                                                                            <style type="text/css" media="print">{"@page { size: auto; }"}</style>
                                                                            {
                                                                                this.state.sortedIdArray.map((resultId) => {
                                                                                    let resultData = this.state.resultList[resultId];
                                                                                    return (
                                                                                        <div className='consolidated-result-section' key={resultData.uniqueId}>
                                                                                            <h5 className='consolidated-result-title'>
                                                                                                Semester {resultData.semesterNumber || '-'} - {resultData.title}
                                                                                            </h5>
                                                                                            <ResultDetails
                                                                                                key={resultData.uniqueId}
                                                                                                resultId={resultData.uniqueId}
                                                                                                resultTitle={resultData.title}
                                                                                                customColumnConfiguration={resultData.customColumnConfiguration || []}
                                                                                                averageGradePointTitle={resultData.averageGradePointTitle}
                                                                                                gradePointLabels={this.state.gradePointLabels}
                                                                                                instituteUrl={this.state.instituteUrl}
                                                                                                instituteLogo={this.state.instituteData.InstituteLogo}
                                                                                                instituteName={this.state.instituteData.InstituteName}
                                                                                                closeViewResult={() => { }}
                                                                                                hideBackButton={true}
                                                                                                hideSearchBlock={true}
                                                                                                hidePrintButton={true}
                                                                                                suppressDefaultPrintPageStyle={true}
                                                                                                fixedAdmissionNumber={this.state.studentPRN}
                                                                                                fixedSearchType='university_number'
                                                                                                autoFetchResult={true}
                                                                                            />
                                                                                        </div>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </div>
                                                                        <div className='printResult'>
                                                                            <ReactToPrint
                                                                                trigger={() => <button className='btn btn-primary waves-effect' title='Click to print consolidated result'>Print Consolidated Result</button>}
                                                                                content={() => this.consolidatedPrintReference}
                                                                                pageStyle='@page { margin: 6mm; } @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }'
                                                                            />
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    selectedResult != undefined &&
                                                                <ResultDetails
                                                                    key={selectedResult.uniqueId}
                                                                    resultId={selectedResult.uniqueId}
                                                                    resultTitle={selectedResult.title}
                                                                    customColumnConfiguration={selectedResult.customColumnConfiguration || []}
                                                                    averageGradePointTitle={selectedResult.averageGradePointTitle}
                                                                    gradePointLabels={this.state.gradePointLabels}
                                                                    instituteUrl={this.state.instituteUrl}
                                                                    instituteLogo={this.state.instituteData.InstituteLogo}
                                                                    instituteName={this.state.instituteData.InstituteName}
                                                                    closeViewResult={() => { }}
                                                                    hideBackButton={true}
                                                                    hideSearchBlock={true}
                                                                    fixedAdmissionNumber={this.state.studentPRN}
                                                                    fixedSearchType='university_number'
                                                                    autoFetchResult={true}
                                                                />
                                                            }

                                                            {
                                                                this.state.total > this.state.limit &&
                                                                <div id='paginationContainer' className='student-result-pagination'>
                                                                    <Pagination
                                                                        activePage={this.state.pageIndex}
                                                                        itemsCountPerPage={this.state.limit}
                                                                        totalItemsCount={this.state.total}
                                                                        pageRangeDisplayed={3}
                                                                        onChange={(num) => this.updatePaginationCount(num)}
                                                                    />
                                                                </div>
                                                            }
                                                        </>
                                                        :
                                                        <div className='invalid-student'>
                                                            <p>No results found for the verified student.</p>
                                                        </div>
                                                }
                                            </>
                                    }
                                </>
                            }
                        </div>
                        :
                        this.state.isValidUrl == 'false' &&
                        <div className='invalid-url'>
                            <p>Invalid URL.</p>
                        </div>
                }

                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
            </>
        );
    }
}

export default StudentResultList;
